export default function AcknowledgeModal({ type = 'listing', onAcknowledge, onCancel }) {
  const isListing = type === 'listing'

  return (
    <div className="modal-overlay">
      <div className="modal-box" style={{ maxWidth: 460, textAlign: 'center' }}>

        <div style={{ fontSize: 52, marginBottom: 16 }}>
          {isListing ? '🌊' : '✏️'}
        </div>

        <h2 style={{ fontSize: 20, fontWeight: 800, marginBottom: 10, letterSpacing: '-.3px' }}>
          {isListing ? 'Your listing goes live instantly!' : 'Your post goes live instantly!'}
        </h2>

        <div style={{
          background: '#eff6ff',
          border: '1.5px solid #bfdbfe',
          borderRadius: 10,
          padding: '14px 18px',
          marginBottom: 20,
          textAlign: 'left',
        }}>
          <p style={{ fontSize: 14, color: '#1e40af', lineHeight: 1.65, fontWeight: 500 }}>
            {isListing
              ? "Your listing will be publicly visible to everyone right away — no waiting! It's also added to our admin review queue so we can keep the directory accurate and spam-free. No worries though, everyone can see it immediately."
              : "Your post will be publicly visible to everyone right away! It's also flagged for our team to review. As long as it follows community guidelines you're good to go."
            }
          </p>
        </div>

        <div style={{
          background: '#f9fafb',
          border: '1px solid var(--gray-200)',
          borderRadius: 8,
          padding: '12px 16px',
          marginBottom: 24,
          textAlign: 'left',
        }}>
          <p style={{ fontSize: 12, color: 'var(--gray-500)', lineHeight: 1.6 }}>
            By submitting you confirm this is accurate information and follows our community guidelines. 
            False or spam listings may be removed without notice.
            Anyone can report a listing using the Report button in the menu.
          </p>
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onCancel} className="btn btn-ghost" style={{ flex: 1 }}>
            Go Back
          </button>
          <button onClick={onAcknowledge} className="btn btn-primary" style={{ flex: 2 }}>
            Got it — Publish! 🚀
          </button>
        </div>
      </div>
    </div>
  )
}
